//components
import { KickerDot } from '@/containers-ai/SectionHeading';
import { CountUp } from '../CountUp';

//styles
import {
  ProofSection,
  BigNums,
  BigNum,
  BigNumValue,
  BigNumLabel,
  SectionTitleCustom,
  KickerCustom,
} from './Proof.styles';

import { Container } from '@/components/Grid';

export const proofOutcomes = [
  { value: 83, suffix: '%', label: 'lower cost per task' },
  { value: 80, suffix: '%', label: 'faster completion time' },
  { value: 100, suffix: 's of hrs', label: 'saved per week' },
];

export function Proof({
  outcomes,
  kicker = 'Outcomes',
  title = 'What Loadsmart AI gives back.',
  locale,
}) {
  return (
    <ProofSection id="proof">
      <Container>
        <KickerCustom>
          <KickerDot />
          {kicker}
        </KickerCustom>
        <SectionTitleCustom>{title}</SectionTitleCustom>

        <BigNums>
          {outcomes.map((outcome) => (
            <BigNum key={outcome.label}>
              <BigNumValue $text={outcome.text != null}>
                {outcome.text ?? (
                  <>
                    {outcome.prefix}
                    <CountUp value={outcome.value} locale={locale} />
                    {outcome.suffix}
                  </>
                )}
              </BigNumValue>
              <BigNumLabel>{outcome.label}</BigNumLabel>
            </BigNum>
          ))}
        </BigNums>
      </Container>
    </ProofSection>
  );
}
